/* eslint-disable max-len */
import type {MessageNamespace} from '@Logger/Constants/MessageNamespace';
import {MessageType} from '@Logger/Constants/MessageType';
import type {TLoggerMessages} from '@Logger/Types/TLoggerMessages';

import type {IPlummetingBuffer} from '../Streams/createPlummetingBufferStream';

import {FeatureBandwidthEstimationMessageId} from './FeatureBandwidthEstimationMessageId';

const featureBandwidthEstimationMessages = {
    [MessageType.INFO]: {
        [FeatureBandwidthEstimationMessageId._001_THROUGHPUT_BASED_ESTIMATE_CHANGED]: (
            bandwidthEstimate: string,
        ): string => `Throughput-based estimate changed to ${bandwidthEstimate}`,
        [FeatureBandwidthEstimationMessageId._002_LATENCY_ESTIMATE_CHANGED]: (latencyEstimate: string): string =>
            `Latency estimate changed to ${latencyEstimate}`,
        [FeatureBandwidthEstimationMessageId._003_TIME_BASED_ESTIMATE_CHANGED]: (bandwidthEstimate: string): string =>
            `Time-based estimate changed to ${bandwidthEstimate}`,
    },
    [MessageType.LOG]: {
        [FeatureBandwidthEstimationMessageId._004_PROLONGED_BUFFERING]: (): string =>
            'Prolonged buffering detected, re-seeding EWMA time-based estimate',
        [FeatureBandwidthEstimationMessageId._005_RESEEDING_PREVENTED]: (
            throughputBasedBandwidthEstimate: string,
            timeBasedBandwidthEstimate: string,
        ): string =>
            `Could not re-seed EWMA time-based estimate ${timeBasedBandwidthEstimate}` +
            ` because throughput-based estimate ${throughputBasedBandwidthEstimate} was unavailable or higher`,
    },
    [MessageType.WARNING]: {
        [FeatureBandwidthEstimationMessageId._000_PLUMMETING_BUFFER]: ({
            activeVariantIndex,
            effectiveVariantCount,

            humanReadableActiveBitrate,
            humanReadableLatencyInclusiveTimeBasedBandwidthEstimate,
            humanReadableThroughputBasedBandwidthEstimate,
            humanReadableTimeBasedBandwidthEstimate,
            requestLatencyEstimate,

            isInsideBuffer,
            isInsideGap,
            hasEndedOrIsEnding,

            normalSegmentDurationSeconds,
            audioBufferAheadDurationSeconds,
            videoBufferAheadDurationSeconds,
        }: IPlummetingBuffer): string =>
            `Plummeting buffer detected, re-seeding EWMA time-based estimate` +
            `\n    Active Variant Index: ${activeVariantIndex}` +
            `\n    Effective Variant Count: ${effectiveVariantCount}` +
            `\n    Active Bitrate: ${humanReadableActiveBitrate}` +
            `\n    Latency Inclusive Time Based Bandwidth Estimate: ${humanReadableLatencyInclusiveTimeBasedBandwidthEstimate}` +
            `\n    Throughput Based Bandwidth Estimate: ${humanReadableThroughputBasedBandwidthEstimate}` +
            `\n    Time Based Bandwidth Estimate: ${humanReadableTimeBasedBandwidthEstimate}` +
            `\n    Request Latency Estimate: ${requestLatencyEstimate}mS` +
            `\n    Is Inside Buffer: ${isInsideBuffer}` +
            `\n    Is Inside Gap: ${isInsideGap}` +
            `\n    Has Ended Or Is Ending: ${hasEndedOrIsEnding}` +
            `\n    Normal Segment Duration: ${normalSegmentDurationSeconds}` +
            `\n    Audio Buffer Duration: ${audioBufferAheadDurationSeconds}` +
            `\n    Video Buffer Duration: ${videoBufferAheadDurationSeconds}`,
    },
    [MessageType.ERROR]: {},
};

export type TFeatureBandwidthEstimationMessages = TLoggerMessages<
    MessageNamespace._003_FEATURE_BANDWIDTH_ESTIMATION,
    typeof featureBandwidthEstimationMessages
>;

export {featureBandwidthEstimationMessages};
